(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[922],{

/***/ 592:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/posts/[slug]",
      function () {
        return __webpack_require__(1786);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2074:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8420);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6159);


const DateFormatter = (param)=>{
    let { dateString  } = param;
    const date = (0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dateString);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("time", {
        dateTime: dateString,
        children: (0,date_fns__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(date, "LLLL	d, yyyy")
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DateFormatter);


/***/ }),

/***/ 5833:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ Tags; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9521);
/* harmony import */ var _Tag__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1149);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  gap: 16px;\n  overflow-x: auto;\n  height: 100%;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}




const StyledContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-45d7fddf-0"
})(_templateObject());
const Tags = (param)=>{
    let { className , items , path  } = param;
    if (!items) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledContainer, {
        className: className,
        children: items.map((item)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Tag__WEBPACK_IMPORTED_MODULE_3__/* .Tag */ .V, {
                text: item,
                path: path || "/tag/".concat(item)
            }, item))
    });
};


/***/ }),

/***/ 8719:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x": function() { return /* binding */ BackButton; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
;// CONCATENATED MODULE: ./components/neutral/ChevronLeft.jsx

const ChevronLeft = (param)=>{
    let { className  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "20",
        height: "20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M12.5 5.5 8 10l4.5 4.5",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
        })
    });
};

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
;// CONCATENATED MODULE: ./components/neutral/BackButton.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      color: ",
        ";\n    "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n  padding: 0;\n  font-size: 16px;\n  color: #2f426c;\n  font-weight: 600;\n  ",
        "\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: none;\n  background: none;\n  padding: 0;\n  margin: 0;\n  outline: none;\n  box-shadow: none;\n  cursor: pointer;\n  font: inherit;\n  color: inherit;\n\n  display: flex;\n  align-items: center;\n  margin-bottom: 16px;\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}





const StyledIcon = (0,styled_components_browser_esm/* default */.ZP)(ChevronLeft).withConfig({
    componentId: "sc-f985a46d-0"
})(_templateObject());
const StyledTitle = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-f985a46d-1"
})(_templateObject2(), (props)=>props.$color && (0,styled_components_browser_esm/* css */.iv)(_templateObject1(), props.$color));
const StyledContainer = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-f985a46d-2"
})(_templateObject3());
const BackButton = (param)=>{
    let { className , color ="#2f426c"  } = param;
    const router = (0,next_router.useRouter)();
    const handleBack = ()=>{
        router.back();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContainer, {
        onClick: handleBack,
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIcon, {
                color: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTitle, {
                $color: color,
                children: "Back"
            })
        ]
    });
};


/***/ }),

/***/ 2936:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);


const MetaTags = (param)=>{
    let { title , description , url , keywords  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: url
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:url",
                content: url
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: url
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: keywords
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                charSet: "utf-8"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                "http-equiv": "X-UA-Compatible",
                content: "IE=edge,chrome=1"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "format-detection",
                content: "telephone=no"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "lang",
                content: "en-US"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "index,follow, max-image-preview:large"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: "https://uicomponentlib.com/assets/icon.png"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "article"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: "uicomponentlib.com"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "google-site-verification",
                content: "d3ZgGUOjRe_WaGoJEL9Xl1F7sXwIycMbyF0kQD8Sl4w"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (MetaTags);


/***/ }),

/***/ 1786:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Post; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./components/DateFormatter.tsx
var DateFormatter = __webpack_require__(2074);
// EXTERNAL MODULE: ./components/Tags/Tags.tsx
var Tags = __webpack_require__(5833);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./components/PostPreview/CoverImage.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}



const StyledImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-a7a42bc7-0"
})(_templateObject());
const CoverImage = (param)=>{
    let { src , title , className  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImage, {
        src: src,
        alt: "Cover Image for ".concat(title),
        className: className
    });
};

;// CONCATENATED MODULE: ./components/PostPreview/preview-utils.ts
const addCopyButtons = ()=>{
    const allCode = document.querySelectorAll("pre");
    if (allCode.length > 0) {
        allCode.forEach((item)=>{
            item.setAttribute("data-before", "copy");
            item.addEventListener("click", (event)=>{
                event.stopImmediatePropagation();
                if (event.target === item) {
                    var _item_childNodes_;
                    const code = (_item_childNodes_ = item === null || item === void 0 ? void 0 : item.childNodes[0]) === null || _item_childNodes_ === void 0 ? void 0 : _item_childNodes_.innerHTML;
                    if (code) {
                        navigator.clipboard.writeText(code);
                        item.setAttribute("data-before", "copied");
                        setTimeout(()=>{
                            item.setAttribute("data-before", "copy");
                        }, 5000);
                    }
                }
            });
        });
    }
};

// EXTERNAL MODULE: ./components/neutral/BackButton.tsx + 1 modules
var BackButton = __webpack_require__(8719);
;// CONCATENATED MODULE: ./components/PostPreview/PostPreview.tsx

function PostPreview_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  padding: 24px 0;\n"
    ]);
    PostPreview_templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 0;\n  margin-bottom: 24px;\n  font-weight: bold;\n  color: ",
        ";\n  line-height: 36px;\n  font-size: 36px;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 12px;\n  color: ",
        ";\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        '\n  .counters {\n    background: lightgray;\n    text-align: left;\n    padding: 5em 8em;\n    margin-top: 7em;\n\n    counter-reset: counter-name;\n  }\n\n  .section {\n    position: relative;\n    counter-increment: section-counter;\n  }\n\n  .section::before {\n    content: counter(section-counter);\n    position: absolute;\n    left: -2.5em;\n    top: -0.5em;\n    background: white;\n    width: 2em;\n    height: 2em;\n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border: 3px solid gray;\n    color: gray;\n    box-sizing: border-box;\n  }\n\n  .counters ol {\n    list-style: none;\n  }\n\n  .counters li::before {\n    counter-increment: ordered-list;\n    content: "list item " counter(ordered-list) ") ";\n    font-size: 0.8em;\n    color: $clr-red;\n  }\n'
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: 16px;\n  margin-bottom: 24px;\n\n  * {\n    color: ",
        ";\n    font-size: 16px;\n  }\n\n  h2 {\n    font-size: 20px;\n  }\n\n  code {\n    background-color: ",
        ";\n    color: ",
        ";\n    padding: 2px 8px;\n    border-radius: 8px;\n    width: 100%;\n    overflow: auto;\n  }\n\n  pre {\n    position: relative;\n    background-color: ",
        ";\n    color: ",
        ";\n    padding: 8px;\n    border-radius: 8px;\n\n    width: 100%;\n    display: flex;\n    overflow: auto;\n\n    .copy {\n      position: absolute;\n      top: 0;\n      right: 0;\n      padding: 4px 8px;\n      background-color: ",
        ";\n      color: ",
        ";\n      border-radius: 8px;\n      cursor: pointer;\n      height: fit-content;\n    }\n  }\n\n  pre:after {\n    content: attr(data-before);\n    position: absolute;\n    top: 0;\n    right: 0;\n    padding: 4px 8px;\n    background-color: ",
        ";\n    border-radius: 8px;\n    cursor: pointer;\n    height: fit-content;\n  }\n\n  a {\n    border: none;\n    outline: none;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    text-decoration: none;\n    box-sizing: border-box;\n    user-select: none;\n    pointer-events: ",
        ";\n    background-color: transparent;\n\n    font-style: normal;\n    font-weight: 600;\n    text-transform: none;\n    min-width: max-content;\n\n    color: ",
        ";\n    background-color: transparent;\n  }\n\n  a:hover {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 24px;\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 24px;\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}








const StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4cfbef50-0"
})(PostPreview_templateObject());
const StyledTitle = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    componentId: "sc-4cfbef50-1"
})(_templateObject1(), (props)=>props.theme.palette.colors.typography[1000]);
const StyledDate = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4cfbef50-2"
})(_templateObject2(), (props)=>props.theme.palette.colors.typography[900]);
const StyledOrderedList = (0,styled_components_browser_esm/* css */.iv)(_templateObject3());
const StyledPreviewText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4cfbef50-3"
})(_templateObject4(), (props)=>props.theme.palette.colors.typography[1000], (props)=>props.theme.palette.colors.typography[1000], (props)=>props.theme.palette.colors.typography[1000], (props)=>props.theme.palette.common.white, (props)=>props.theme.palette.colors.typography[1000], (props)=>props.theme.palette.common.white, (props)=>props.theme.palette.colors.purple[700], (props)=>props.theme.palette.common.white, (props)=>props.theme.palette.colors.purple[700], (props)=>props.disabled ? "none" : "all", (props)=>props.theme.palette.colors.blue[300], (props)=>props.theme.palette.colors.blue[400]);
const StyledTags = (0,styled_components_browser_esm/* default */.ZP)(Tags/* Tags */.$).withConfig({
    componentId: "sc-4cfbef50-4"
})(_templateObject5());
const StyledCoverImage = (0,styled_components_browser_esm/* default */.ZP)(CoverImage).withConfig({
    componentId: "sc-4cfbef50-5"
})(_templateObject6());
function PostPreview(param) {
    let { item  } = param;
    const { title , name , date , content , tags , coverImage  } = item;
    (0,react.useEffect)(()=>{
        addCopyButtons();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BackButton/* BackButton */.x, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTags, {
                items: tags
            }),
            coverImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCoverImage, {
                src: coverImage,
                title: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTitle, {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDate, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DateFormatter/* default */.Z, {
                    dateString: date
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPreviewText, {
                dangerouslySetInnerHTML: {
                    __html: content
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTags, {
                items: tags
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/PostPreview/index.ts


// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(8680);
// EXTERNAL MODULE: ./pages/MetaTags.tsx
var MetaTags = __webpack_require__(2936);
;// CONCATENATED MODULE: ./pages/posts/[slug].tsx

function _slug_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _slug_templateObject = function() {
        return data;
    };
    return data;
}







const _slug_StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3f0badd1-0"
})(_slug_templateObject());
var __N_SSG = true;
function Post(param) {
    let { post  } = param;
    const router = (0,next_router.useRouter)();
    // if (!router.isFallback && !post?.slug) {
    //   return <ErrorPage statusCode={404} />
    // }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(_slug_StyledContainer, {
        children: router.isFallback ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: "Loading…"
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTags["default"], {
                    title: post === null || post === void 0 ? void 0 : post.title,
                    description: post.excerpt,
                    url: "".concat(constants/* APP_URL */.FX, "/posts/").concat(post === null || post === void 0 ? void 0 : post.slug),
                    keywords: constants/* APP_KEYWORDS */.pI
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PostPreview, {
                    item: post
                })
            ]
        })
    });
}


/***/ }),

/***/ 1163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(880)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [358,774,888,179], function() { return __webpack_exec__(592); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);